import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=1d2d760c&scoped=true"
import script from "./productCenter.vue?vue&type=script&lang=js"
export * from "./productCenter.vue?vue&type=script&lang=js"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=1d2d760c&prod&scoped=true&lang=css"
import style1 from "./productCenter.vue?vue&type=style&index=1&id=1d2d760c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2d760c",
  null
  
)

export default component.exports